import { ConfigProvider } from "antd";
import React, { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "react-hot-toast";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ErrorScreen } from "./components/error-screen";
import { FONTFAMILY } from "./constants/roles";
import i18n from "./i18n";
import { Router } from "./routes";
import reduxStore from "./store";

export const { store, persistor } = reduxStore();

const App = () => (
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorScreen}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <I18nextProvider i18n={i18n}>
            <Suspense fallback="loading">
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#F7941D",
                    borderRadius: 2,
                  },
                }}
              >
                <Toaster
                  toastOptions={{ style: { fontFamily: FONTFAMILY.ROBOTO } }}
                />
                <Router />
              </ConfigProvider>
            </Suspense>
          </I18nextProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

export default App;
